import React, { useState, useRef, useEffect } from "react";
import "./grantModal.css";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { postUserInfo } from "../../../redux/userInfo/userAction";

import FadeLoader from "react-spinners/FadeLoader";

const GrantModal = ({ setIsOpen, userGuideInfo, title, message }) => {
  const [loading, setLoading] = useState(true);
  const modalRef = useRef();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const qValue = queryParams.get("q");
  const dispatch = useDispatch();

  // useEffect(() => {
  //   setLoading(true);
  //   setTimeout(() => {
  //     setLoading(false);
  //   }, 3000);
  // }, []);

  useEffect(() => {
    setLoading(false);
    // dispatch(postUserInfo(qValue))
    //   .then(() => {
    //     setLoading(false);
    //   })
    //   .catch(() => {
    //     console.log(error);
    //     setLoading(false);
    //   });
  }, [qValue]);

  useEffect(() => {
    //Add event listener to detect clicks outside the modal
    const handleClickOutside = (e) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        //Click occurred outside the modal, close it
        setIsOpen(false);
      }
    };

    //Attach the event listener to the document
    document.addEventListener("mousedown", handleClickOutside);

    //Clean up the event listener when the component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setIsOpen]);

  return (
    <div className="myodal">
      {loading ? (
        <FadeLoader color={"#B70303"} loading={loading} size={100} />
      ) : (
        <div ref={modalRef}>
          <div className="granted flex flex-col items-center justify-center h-screen">
            <IoIosCheckmarkCircle size={100} color="green" />
            <span className="button">{title}</span>
            <p className="text">{message}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default GrantModal;
